/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".navaid-listing[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;background:#fff;padding:0 1em}.navaid-listing__navaid[_ngcontent-%COMP%]{flex-basis:50%;border-bottom:1px solid #eee}@media screen and (max-width:760px){.navaid-listing__navaid[_ngcontent-%COMP%]{flex-basis:100%}}"];
export { styles as styles };
